import {
  NumericTextBox,
  NumericTextBoxChangeEvent
} from '@progress/kendo-react-inputs'
import { StackLayout } from '@progress/kendo-react-layout'
import { FC } from 'react'

export interface FromToNumberInputProps {
  limitLeftValue?: number
  limitRightValue?: number
  onLimitLeftChange?: (value: number | null) => void
  onLimitRightChange?: (value: number | null) => void
}
export const FromToNumberInput: FC<FromToNumberInputProps> = ({
  limitLeftValue,
  limitRightValue,
  onLimitLeftChange,
  onLimitRightChange
}) => {
  const createValue = (LimitValue?: number) => {
    return LimitValue === undefined ? null : LimitValue
  }

  const handleLeftChange = (event: NumericTextBoxChangeEvent) => {
    onLimitLeftChange?.(event.value)
  }

  const handleRightChange = (event: NumericTextBoxChangeEvent) => {
    onLimitRightChange?.(event.value)
  }
  return (
    <StackLayout orientation='horizontal'>
      <NumericTextBox
        onChange={handleLeftChange}
        value={createValue(limitLeftValue)}
        min={0}
        spinners={false}
      />
      {'　～　'}
      <NumericTextBox
        onChange={handleRightChange}
        value={createValue(limitRightValue)}
        min={0}
        spinners={false}
      />
    </StackLayout>
  )
}
